<template>
  <div class="scalecontrol-container">
    <div>
      <label>Dias</label>
      <ul class="list-days">
        <li
          v-for="({ date, active, selected }, index) in value"
          :key="index"
          :class="[active ? 'active' : '', selected ? 'selected' : '']"
          @click="toggleSelectDay(index)"
        >
          {{ dateFormatDDMM(date) }}
        </li>
      </ul>
    </div>
    <div>
      <label for="">Períodos</label>
      <ul class="list-times">
        <li v-for="({ entrada, saida }, index) in times" :key="entrada + saida">
          <article>
            <div v-if="entrada === ''">
              <i class="fa  fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
            </div>
            <span v-else>{{ entrada }}</span>

            <span>-</span>

            <div v-if="saida === ''">
              <i class="fa  fa-arrow-circle-right fa-lg" aria-hidden="true"></i>
            </div>
            <span v-else>{{ saida }}</span>

            <button @click="() => removeTime(index)">
              ×
            </button>
          </article>
        </li>
        <li v-show="shownFormTime">
          <form spellcheck="false">

            <input ref="entrada" 
               type="time" 
               class="form-control" 
               v-model="entrada"
               @blur="lockIfValueIsNull">

            <input ref="saida" 
               type="time" 
               class="form-control" 
               v-model="saida"
               @blur="lockIfValueIsNull">

            <!-- <input
              v-model="entrada"
              @keydown="keydownFormatTime"
              v-mask="'##h##'"
            />
            <input
              v-model="saida"
              @keydown="keydownFormatTime"
              v-mask="'##h##'"
            /> -->
            <button @click.prevent="addTime">
              +
            </button>
          </form>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import { lockIfValueIsNull } from '@/utils/events'
import { parseTimeToInt } from '@/utils/times'

export default {
  props: {
    value: Array
  },
  created() {
    this.scale = this.value.map(({ times, ...rest }) => ({
      times: [...times],
      ...rest,
      selected: false
    }))
  },
  data() {
    return {
      scale: [],
      selectedIndex: -1,
      times: [],
      entrada: '',
      saida: ''
    }
  },
  computed: {
    shownFormTime() {
      return this.selectedIndex > -1 && this.times.length < 3
    },
    diasAtivos () {
      return this.scale.filter(item => item.active).length
    }
  },
  watch: {
    diasAtivos (value) {
      if (value === 0) this.$emit('remove')
    }
  },
  methods: {
    dateFormatDDMM(date) {
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit'
      })
    },
    toggleSelectDay(index) {
      const { selected } = this.scale[index]
      if (selected) {
        this.unSelectDay(index)
      } else {
        this.selectDay(index)
      }
    },
    unSelectDay(index) {
      this.selectedIndex = -1

      this.scale[index].active = false
      this.scale[index].selected = false
      this.times = []

      this.update()
    },
    selectDay(index) {
      const { scale } = this
      // deseleciona todos os selecionados
      scale
        .filter(({ selected }) => selected)
        .forEach(date => {
          date.selected = false
        })

      scale[index].active = true
      scale[index].selected = true
      const { times } = scale[index]

      this.times = [...times]

      if (this.times.length > 0) {
        this.update()
      }

      this.selectedIndex = index
    },
    addTime() {
      this.entrada = this.formatTime(this.entrada)
      this.saida = this.formatTime(this.saida)

      const { entrada, saida, scale, selectedIndex } = this
      const daySelected = scale[selectedIndex]
      const lastScaleIndex = scale.length - 1
      const lastDay = scale[lastScaleIndex]

      // verifica se o dia selecionado é o ultimo da escala
      if (lastDay.date === daySelected.date) {
        // se for mudar a saida do time para as 23h59
        this.saida = '23h59'
        this.addTimeLeaveOnDay()
        return
      }

      switch (this.getTimeType({ entrada, saida })) {
        case 'leaveOnDay':
          this.addTimeLeaveOnDay()
          break
        case 'leaveOnNextDay':
          this.addTimeLeaveOnNextDay()
          break
        default:
          break
      }
    },
    formatTime(time) {
      if (time.length === 0) {
        return time
      }

      if (time.length === 2) {
        return `${time}h00`
      }

      return time
    },
    getTimeType({ entrada, saida }) {
      if (entrada === '' && saida === '') return ''
      if (entrada === '') return 'timeOut'
      if (saida === '') return 'timeIn'

      const entradaNumber = parseInt(entrada.replace(/\D/, ''))
      const saidaNumber = parseInt(saida.replace(/\D/, ''))

      if (entradaNumber < saidaNumber) return 'leaveOnDay'
      if (entradaNumber >= saidaNumber) return 'leaveOnNextDay'
    },
    addTimeLeaveOnDay() {
      const { entrada, saida, selectedIndex } = this

      if (!this.validTime({ entrada, saida })) {
        this.$toastr.e(
          'Esse período é inválido, verifique se há algum conflito!'
        )
        return
      }

      this.times.push({ entrada, saida })
      this.scale[selectedIndex].times = [...this.times]
      this.update()
      this.reset()
    },
    addTimeLeaveOnNextDay() {
      const { entrada, saida, selectedIndex } = this
      const timeIn = { entrada, saida: '' }
      const timeOut = { entrada: '', saida }

      const timesIn = this.scale[selectedIndex].times
      if (!this.validTime(timeIn, timesIn)) {
        this.$toastr.e(
          `Esse período é inválido, verifique se há algum conflito no dia ${
            this.scale[selectedIndex].day
          }!`
        )
        return
      }

      const timesOut = this.scale[selectedIndex + 1].times
      if (!this.validTime(timeOut, timesOut)) {
        this.$toastr.e(
          `Esse período é inválido, verifique se há algum conflito no dia ${
            this.scale[selectedIndex + 1].day
          }!`
        )
      }

      // add time
      timesIn.push({ entrada, saida: '' })
      timesOut.push({ entrada: '', saida })

      this.times.push({ entrada, saida: '' })

      this.scale[selectedIndex].times = [...timesIn]
      this.scale[selectedIndex + 1].times = [...timesOut]
      this.scale[selectedIndex + 1].active = true

      this.update()
      this.reset()
    },
    removeTime(index) {
      this.times.splice(index, 1)
      this.scale[this.selectedIndex].times = [...this.times]
      this.update()
    },
    validTime(time, times) {
      let isValid = true

      if (!times) {
        times = this.scale[this.selectedIndex].times
      }

      const timeNew = parseTimeToInt(time)

      let index = 0
      while (isValid && index < times.length) {
        const time = parseTimeToInt(times[index++])
        let timeIsBefore = false
        let timeIsAfter = false

        // verificar se o time é anterior
        if (
          typeof timeNew.saida === 'number' &&
          typeof time.entrada === 'number'
        ) {
          timeIsBefore = timeNew.saida <= time.entrada
        }

        // verificar se o time é posterior
        if (
          typeof timeNew.entrada === 'number' &&
          typeof time.saida === 'number'
        ) {
          timeIsAfter = timeNew.entrada >= time.saida
        }

        isValid = timeIsBefore || timeIsAfter
      }

      return isValid
    },
    reset() {
      this.entrada = ''
      this.saida = ''
    },
    update() {
      if (this.diasAtivos > 0)
        this.$emit('input', [...this.scale])
    },
    lockIfValueIsNull
  }
}
</script>

<style scoped>
div.scalecontrol-container {
  display: flex;
}

div.scalecontrol-container > div {
  display: flex;
  flex-direction: column;
  justify-content: start;
}

div.scalecontrol-container > div:first-child {
  flex: 2;
}

div.scalecontrol-container > div:last-child {
  flex: 5;
}

label {
  font-size: 11px;
  text-align: center;
  margin-bottom: 0px;
}

ul {
  height: 80px;
  border: solid 1px #ccc;
  border-radius: 4px;
  margin: 0px;
  clear: none;
}

ul.list-days {
  min-width: 50px;
  overflow-x: hidden;
  overflow-y: scroll;
  border-right: none;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  scrollbar-width: 2px;
  padding: 0px;
}

ul.list-days::-webkit-scrollbar {
  width: 5px;
}

ul.list-days::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(70, 140, 54, 0.2);
  border-radius: 10px;
}

ul.list-days::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(70, 140, 54, 1);
}

li {
  list-style: none;
}

ul.list-days li {
  text-align: center;
  border-right: solid 1px #ccc;
  border-bottom: solid 1px #ccc;
}

ul.list-days li:hover,
ul.list-days li.active:hover,
ul.list-days li.selected,
ul.list-days li.active.selected {
  cursor: pointer;
  color: #fff;
  transition: background-color 0.2s ease-out;
  background-color: rgba(70, 140, 54, 0.5);
}

ul.list-days li.active {
  color: #fff;
  background-color: rgba(70, 140, 54, 0.8) !important;
}

ul.list-times {
  min-width: 105px;
  padding: 5px 5px 0px 5px;
  border-left: none;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

article {
  display: flex;
  list-style: none;
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  border-radius: 4px;
  border: 1px solid transparent;
  margin-bottom: 5px;
  padding-left: 5px;
  font-size: 11px;
  font-weight: 600;
  justify-content: space-between;
  align-items: center;
}

article > div {
  display: flex;
  justify-content: center;
  align-items: center;
}

article > div:first-child {
  width: 65px;
}

form {
  display: flex;
  margin-bottom: 5px;
}

input {
  width: 100%;
  height: 20px;
  margin: 0 5px 0 0;
  border: none; /* <-- This thing here */
  border: solid 1px #ccc;
  border-radius: 4px;
  font-size: 11px;
}

form button {
  color: #3c763d;
  opacity: 1;
}

button {
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
  -webkit-appearance: none;
  float: right;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
</style>


// WEBPACK FOOTER //
// src/components/Employee/ScaleControl.vue